// https://stackoverflow.com/questions/1091372/getting-the-clients-time-zone-and-offset-in-javascript?rq=1

import React, { useContext } from "react";
import Moment from "react-moment";
import "moment-timezone";
import TimeZoneContext from "/app/src/contexts/TimeZoneContext";
import { convertTimeZoneToUTC } from "/app/src/helpers/time";

/**
 * Converts the provided date to a formatted string in the local timezone.
 *
 * @param {Object} param0 - The function parameters.
 * @param {string|Date} param0.date - The date value to convert.
 * @param {boolean} param0.includeSeconds - Whether to include seconds in the formatted output.
 * @param {string} param0.format - The format string for the output date.
 * @returns {React.Element} The formatted date wrapped in a Moment component.
 */
export default function ConvertToLocalTimezone({
  date = "",
  includeSeconds = false,
  format = "dddd, MMMM Do YYYY, h:mm a",
}: {
  date?: string | Date;
  includeSeconds?: boolean;
  format?: string;
}) {
  if (includeSeconds) {
    format = "dddd, MMMM Do YYYY, h:mm:ss a";
  }
  const { timeZone } = useContext(TimeZoneContext);

  if (!date) {
    return null;
  }

  return (
    <Moment format={format} utc tz={timeZone}>
      {date}
    </Moment>
  );
}

/**
 * Converts the powerpick date to the local timezone
 */
export function PowerPickTimeZoneToLocal({
  date = "",
  format = "dddd, MMMM Do YYYY, h:mm a",
}: {
  date?: string | Date;
  format?: string;
}) {
  const { powerPickTimeZone, timeZone } = useContext(TimeZoneContext);
  //adjust the powerpick timezone to utc, then local timezone
  if (!date) {
    return null;
  }
  return (
    <Moment format={format} utc tz={timeZone}>
      {convertTimeZoneToUTC(date, powerPickTimeZone)}
    </Moment>
  );
}
